<div class="container-fluid">

  <div class="row s-contentheader">
    <div class="col-md-12">
      <div>
        <h2 class="text-center">{{customLabel('PRODUCTLINK', 'titlePRD')}}<br />{{catName}}</h2>
        <div class="s-dividerx"></div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-3">&nbsp;</div>

    <div class="col-md-6">

      <div class="card mb-4">
        <div class="card-header s-detailscardheader">
          <div><span><i class="fa fa-clock s-detailscardfa"></i> {{selectedProduct?.DureePRO}}</span></div>
          <div *ngIf="listPrices.length < 2"><span><i class="fa fa-coins s-detailscardfa"></i> {{listPrices[0].Value}}</span></div>
          <div *ngIf="selectedProduct?.PjextPRO && selectedProduct?.PjextPRO !== ''">
            <span (click)="downloadDoc()"><i class="fa fa-file-pdf s-detailscardfa"></i> {{'productsheet'|localize}}</span>
          </div>
        </div>
        <div class="card-body s-detailscardbody">
          <blockquote class="mb-0 p-5">
            <h3 title="{{selectedProduct?.Ident}}">{{selectedProduct?.DesigPRO}}</h3>
            <footer class="blockquote-footer"><cite title="Source Title">{{selectedProductStagesList?.length}}</cite> {{'cardfooterPRD'|localize}}</footer>

            <p>&nbsp;</p>

            <div *ngIf="selectedProduct?.DescrPRO !== ''">
              <h4 class="font-weight-bold">{{'description'|localize}}</h4>
              <p>{{selectedProduct?.DescrPRO}}</p>
            </div>

            <div *ngIf="selectedProduct?.PreRePRO !== ''">
              <h4 class="font-weight-bold">{{'prerequis'|localize}}</h4>
              <p class="wraptext">{{selectedProduct?.PreRePRO}}</p>
            </div>

            <div *ngIf="selectedProduct?.ProgrPRO !== ''">
              <h4 class="font-weight-bold">{{'program'|localize}}</h4>
              <p class="wraptext">{{selectedProduct?.ProgrPRO}}</p>
            </div>

            <div *ngIf="selectedProduct?.PedagPRO !== ''">
              <h4 class="font-weight-bold">{{'pedagogy'|localize}}</h4>
              <p class="wraptext">{{selectedProduct?.PedagPRO}}</p>
            </div>

            <div class="mb-1" *ngIf="optFields?.length > 0">
              <div *ngFor="let of of optFields">
                <h4 class="font-weight-bold" *ngIf="of.ColumnValue !== ''">{{of.ColumnField}}</h4>
                <p class="wraptext" *ngIf="of.ColumnValue !== ''">{{of.ColumnValue}}</p>
              </div>
            </div>
            <ng-container *ngIf="listPrices.length > 1">
              <div class="mb-1">
                <div  *ngFor="let p of listPrices">
                  <h4 class="font-weight-bold" >{{p.Tooltip}}</h4>
                  <p class="wraptext"><label class="wraptext">{{p.Value}}</label></p>
                </div>
              </div>
            </ng-container>
          </blockquote>
        </div>
      </div>

    </div>

    <div class="col-md-3">
      <div class="w-100 text-center">
        <button class="btn btn-default btn-lg mb-3 s-detailsbutton" (click)="selectProduct('')" *ngIf="hasResponsable">{{'inforequest'|localize}}</button>
        <button class="btn btn-default btn-lg mb-3 s-detailsbutton" (click)="selectProduct('/stages/lists')" *ngIf="this.selectedProductStagesList.length > 0">{{'relatedsess'|localize}}</button>
        <label *ngIf="this.selectedProductStagesList.length === 0">{{store.getTrad('noproductstages')}}</label>
      </div>
    </div>
  </div>
</div>



